import { ICourseOfferingByCategoryQuery } from '../interfaces/course-offering-by-category.query.interface';
import { OfferingGroup } from './group.model';
import { CourseOffering } from './course-offering.model';

// @dynamic
export class CourseOfferingsByCategory {
    id: string;
    group: OfferingGroup;
    offerings: CourseOffering[];

    constructor(courseOfferingQuery: ICourseOfferingByCategoryQuery, courseOfferingId?: string) {
        if (courseOfferingQuery) {
            this.id = courseOfferingId ? courseOfferingId : null;
            this.group = courseOfferingQuery.group ? new OfferingGroup(courseOfferingQuery.group) : null;
            this.offerings = courseOfferingQuery.offerings.length ? courseOfferingQuery.offerings.map((offering) => new CourseOffering(offering, courseOfferingQuery.group)) : [];
        }
    }
}
